import {createGlobalStyle} from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --windowHeight: 100vh;
    --red: red;
    --yellow: yellow;
    --green: green;
    --blue: blue;
    --purple: purple;
    --pink: pink;
    --darkBlue: darkBlue;
    --darkRed: darkRed;
    --darkGreen: darkGreen;
    --black: black;
    --white: white;

    // Colour sets

    // Purple
    --color-1: ${(props) => props.theme.colors.color1};
    --color-2: ${(props) => props.theme.colors.color2};
    --color-3: ${(props) => props.theme.colors.color3};
    --color-4: ${(props) => props.theme.colors.color4};
    --color-5: ${(props) => props.theme.colors.color5};
    --color-6: ${(props) => props.theme.colors.color6};
    --color-7: ${(props) => props.theme.colors.color7};
    --color-8: ${(props) => props.theme.colors.color8};
    --color-9: ${(props) => props.theme.colors.color9};
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${(props) => props.theme.fluidType(0)};
    overscroll-behavior: none;

    * { box-sizing: border-box; }
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    color: ${(props) => props.theme.colors.color1};
    background-color: #fff;
  }

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    line-height: 1.1;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: bold;

    a { text-decoration: none; }

    a:hover { text-decoration: none; }
  }

  p,
  ol, ul, li,
  code, kbd, pre, samp {
    line-height: 1.5;
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }

  h1, .h1 {
    ${(props) => props.theme.fluidType(4)};
    text-transform: uppercase;
    @media ( ${(props) => props.theme.breakpoints.md} ) {
      ${(props) => props.theme.fluidType(7)};
    }
  }

  h2, .h2 {
    ${(props) => props.theme.fluidType(0)};
    text-transform: uppercase;
  }

  h3, .h3 { ${(props) => props.theme.fluidType(2)}; }

  h4, .h4 { ${(props) => props.theme.fluidType(1)}; }

  h5, .h5 { ${(props) => props.theme.fluidType(0)}; }

  h6, .h6 { ${(props) => props.theme.fluidType(-1)}; }

  p { ${(props) => props.theme.fluidType(0)}; }

  li {
    margin-top: 0;
    margin-bottom: 0;
  }

  small, p.small { ${(props) => props.theme.fluidType(-1)}; }

  code, kbd, pre, samp {
    font-family: monospace;
    white-space: normal;
  }

  ul {
    padding-left: 1rem;
    list-style-type: disc;
  }

  ol {
    padding-left: 1rem;
    list-style-type: decimal;
  }

  video {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }

  // Specific to PrismicRichText component
  .block-img {
    img {
      width: 100%;
      height: auto;
      display: block;
      margin: 3rem 0;
    }
  }

  // Specific to PrismicRichText component
  .embed {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    margin: 3rem 0;

    iframe,
    object,
    embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  em, i { font-style: italic; }

  strong, b { font-weight: bold; }

  blockquote {
    font-weight: bold;
    padding-left: 1rem;
  }

  a { color: inherit; }

  sup, sub {
    vertical-align: baseline;
    position: relative;
    top: -0.4em;
  }

  sub { top: 0.4em; }

  label, .label {
    ${(props) => props.theme.fluidType(-1)};
    line-height: 1.2;
    font-weight: normal;
    margin: 0 0 0.5rem 0;
    display: block;
    opacity: 0.6;
    font-style: italic;
  }

  fieldset {
    margin: 0;
    padding: 0;
    border: none;
  }

  input[type=range] {
    height: 12px;
    -webkit-appearance: none;
    margin: 0;
    width: 100%;
    background-color: transparent;
  }

  input[type=range]:focus {
    outline: none;
  }

  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    animate: 0.2s;
    background: ${(props) => props.theme.colors.color2};
    border: none;
  }

  input[type=range]::-webkit-slider-thumb {
    border: none;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.color1};
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4px;
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: ${(props) => props.theme.colors.color2};
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    animate: 0.2s;
    background: ${(props) => props.theme.colors.color2};
    border: none;
  }

  input[type=range]::-moz-range-thumb {
    border: none;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.color1};
    cursor: pointer;
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  input[type=range]::-ms-fill-lower {
    background: var(--white);
    border: 1px solid #000000;
    border-radius: 10px;
  }

  input[type=range]::-ms-fill-upper {
    background: var(--white);
    border: 1px solid #000000;
    border-radius: 10px;
  }

  input[type=range]::-ms-thumb {
    margin-top: 1px;
    border: 1px solid #000000;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: #FFFFFF;
    cursor: pointer;
  }

  input[type=range]:focus::-ms-fill-lower {
    background: var(--white);
  }

  input[type=range]:focus::-ms-fill-upper {
    background: var(--white);
  }


  .text-input,
  input[type="text"],
  input[type="password"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="email"],
  input[type="month"],
  input[type="number"],
  input[type="search"],
  input[type="tel"],
  input[type="time"],
  input[type="url"],
  input[type="week"],
  textarea {
    display: block;
    font-family: inherit;
    ${(props) => props.theme.fluidType(0)};
    padding: 0.2rem 0.75rem;
    margin: 0;
    color: ${(props) => props.theme.colors.color1};
    border: 1px ${(props) => props.theme.colors.color1} solid;
    border-radius: 500px;
    line-height: 1.6;
    background-color: transparent;
    -webkit-appearance: none;
    width: 100%;

    &:focus {
      border: 1px ${(props) => props.theme.colors.color2} solid;
    }
  }

  ::placeholder {
    color: ${(props) => props.theme.colors.color1};
    opacity: 0.6;
  }

  .file-input,
  input[type="file"],
  .radio-input,
  input[type="radio"],
  .checkbox-input,
  input[type="checkbox"],
  select {
    font-family: inherit;
  }

  // Select

  select {
    // A reset of styles, including removing the default dropdown arrow
    appearance: none;
    // Additional resets for further consistency
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 2rem;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
    outline: none;
    color: ${(props) => props.theme.colors.color1};
  }

  select::-ms-expand {
    display: none;
  }

  .select-holder {
    width: 100%;
    color: ${(props) => props.theme.colors.color1};
    border: 1px ${(props) => props.theme.colors.color1} solid;
    border-radius: 500px;
    padding: 0 0.75rem;
    margin: 0.5rem 0 0 0;
    ${(props) => props.theme.fluidType(0)};
    cursor: pointer;
    line-height: 1.1;
    background-color: transparent;
    grid-template-areas: "select";
    display: grid;
    align-items: center;
    max-width: 15rem;

    &:after {
      content: "";
      width: 0.8rem;
      height: 0.5rem;
      background-color: ${(props) => props.theme.colors.color1};
      clip-path: polygon(100% 0%, 0 0%, 50% 100%);
      justify-self: end;
      pointer-events: none;
    }

    select,
    &:after {
      grid-area: select;
    }
  }

  .button,
  button,
  input[type="submit"],
  input[type="button"],
  input[type="reset"] {
    display: block;
    padding: 0;
    font-family: inherit;
    ${(props) => props.theme.fluidType(0)};
    line-height: inherit;
    text-decoration: none;
    white-space: nowrap;
    border: none;
    cursor: pointer;
    color: inherit;
    background-color: transparent;

    &:hover {
      text-decoration: none;
    }
  }

  .errorMsg {
    color: ${(props) => props.theme.colors.red};
  }
`;

export default GlobalStyle;
